import React from "react";

import styles from "./index.module.css";

interface QRCodeStubProps {
  ticketNumber?: string;
  className?: string;
}

const QRCodeStub: React.FC<QRCodeStubProps> = ({ ticketNumber, className }) => {
  return (
    <div
      className={`${styles.qrCodeContainer} ${styles.stub} ${className || ""}`}
    >
      <h2 className={styles.title}>{`Видеобилет «${ticketNumber}»`}</h2>
      <div className={styles.qrCodeWrapper}>
        <div className={styles.processingText}>
          «Ваше видео обрабатывается
          <br />
          и появится здесь в течение
          <br />
          24 часов после проката»
        </div>
      </div>
    </div>
  );
};

export default QRCodeStub;
